import { gql } from '@/shared/graphql/generated/lp';

export const getAccountLiquiditySnapshots = gql(/* GraphQL */ `
  query GetAccountLiquiditySnapshots(
    $idSs58: String!
    $minTimestamp: Datetime!
    $maxTimestamp: Datetime!
    $groupBy: [LiquiditySnapshotGroupBy!]!
  ) {
    account: accountByIdSs58(idSs58: $idSs58) {
      snapshots: liquiditySnapshotsByLiquidityProviderId(
        filter: {
          and: [
            { timestamp: { greaterThanOrEqualTo: $minTimestamp } }
            { timestamp: { lessThanOrEqualTo: $maxTimestamp } }
          ]
        }
        orderBy: TIMESTAMP_DESC
      ) {
        agg: groupedAggregates(groupBy: $groupBy) {
          keys
          max {
            totalLiquidityUsd
          }
        }
      }
    }
  }
`);
